<style lang="scss">





.contactTitle1 {
  margin-top: 5rem;
  display: flex;
  flex-direction: column;
  justify-items: flex-start;
  align-items: center;
  .contact-title {
    font-size: 25px;
    font-family:  'PingFang SC','Microsoft YaHei';
    font-weight: bold;
    color: #353535;
  }
  .contact-subtitle {
    font-size: 16px;
    font-family: 'PingFang SC','Microsoft YaHei';
    font-weight: 400;
    color: #7d7d7d;
  }
  .contact-block-list {
    display: flex;
    flex-direction: row;
    justify-items: center;
    align-items: center;
    margin-top: 2rem;
    .contact-block-item {
      width: 43px;
      height: 4px;
      background: #e5004f;
      margin-left: 0.2rem;
    }
  }
}
</style>

<template>
  <div class="contactTitle1">
    <div class="contact-title">与我们合作</div>
    <!-- <div class="contact-subtitle">
      "To make shopping mall business easy"
    </div> -->
    <div class="contact-block-list">
      <div class="contact-block-item"></div>
      <div class="contact-block-item"></div>
      <div class="contact-block-item"></div>
    </div>
  </div>
</template>

<script>
export default {
  name: "title",
  components: {},
  data() {
    return {};
  },
  mounted() {},
  methods: {},
};
</script>
